module.exports = __webpack_public_path__ + "img/factor_a.821b1185.svg";